var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{'hubble-plot-y-axis-scale-control': true, 'taller': _vm.tallerGraph}},[_c('v-range-slider',{attrs:{"dense":"","min":_vm.minValue,"max":_vm.maxValue,"value":_vm.displayValue,"step":0.1,"thumb-label":true,"vertical":""},on:{"input":function($event){return _vm.setRangeValue($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }